import packageJson from '../../package.json'; 

export class EnvironmentService {
    public static getApplicationId(): string {
      return import.meta.env.VITE_APP_APPLICATION_ID!;
    }
    public static getSecureAPIHost(): string {
      return `https://${import.meta.env.VITE_APP_API_HOST!}`;
    }
    public static getAppURL(): string {
      return `https://${import.meta.env.VITE_APP_URL!}`;
    }
    public static getSegmentKey(): string {
      return import.meta.env.VITE_APP_SEGMENT_KEY!;
    }
    public static getCDNHost(): string {
      return import.meta.env.VITE_APP_CDN_HOST!;
    }
    public static getSentryDSN(): string {
      return import.meta.env.VITE_APP_SENTRY_DSN!;
    }
    /**
     * Extracts Sentry organization slug from DSN
     * DSN format: https://[key]@[org].ingest.sentry.io/[project-id]
     */
    public static getSentryOrg(): string {
      const dsn: string = this.getSentryDSN();
      if (!dsn) return '';
      // Extract org from DSN: https://key@org.ingest.sentry.io/project-id
      const match: RegExpMatchArray | null = dsn.match(/https:\/\/[^@]+@([^.]+)\.ingest\.sentry\.io/);
      return match ? match[1] : import.meta.env.VITE_APP_SENTRY_ORG || '';
    }
    /**
     * Gets Sentry project slug from environment variable
     * This cannot be extracted from DSN reliably, must be set explicitly
     */
    public static getSentryProject(): string {
      return import.meta.env.VITE_APP_SENTRY_PROJECT || '';
    }
    /**
     * Gets Sentry auth token for sourcemap uploads
     * Must be created at: https://sentry.io/settings/account/api/auth-tokens/
     */
    public static getSentryAuthToken(): string {
      return import.meta.env.VITE_APP_SENTRY_AUTH_TOKEN || '';
    }
    public static getNodeEnv(): string {
      return import.meta.env.VITE_APP_NODE_ENV!;
    }
    public static getPlaidEnv(): string {
      return import.meta.env.VITE_APP_PLAID_ENV!;
    }
    public static getGoogleAPIKey(): string {
      return import.meta.env.VITE_APP_GOOGLE_API_KEY!;
    }
    public static getAPIHost(): string {
      return import.meta.env.VITE_APP_API_HOST!;
    }
    /**
     * Legacy / auth host for PKCE and similar endpoints that remain on `.com`
     * while product APIs may use a different host (e.g. `.io`).
     * Falls back to `VITE_APP_API_HOST` when unset.
     */
    public static getLegacyAPIHost(): string {
      return (
        import.meta.env.VITE_APP_LEGACY_API_HOST?.trim() ||
        import.meta.env.VITE_APP_API_HOST!
      );
    }
    public static getVersion(): string {
      return packageJson.version;
    }
    public static getClarityProjectId(): string {
      return import.meta.env.VITE_APP_CLARITY_PROJECT_ID!;
    }
    public static getPlaidIsVisible(): boolean {
      return import.meta.env.VITE_APP_PLAID_IS_VISIBLE === 'true';
    }
    public static getPazeSDKURL(): string {
      return import.meta.env.VITE_APP_PAZE_SDK_URL!;
    }
    public static getVisaClientID(): string {
      return import.meta.env.VITE_APP_VISA_CLIENT_ID!;
    }
    public static getVisaRedirectURL(): string {
      return import.meta.env.VITE_APP_VISA_REDIRECT_URL!;
    }
    public static getThreatMatrixOrgId(): string {
      return import.meta.env.VITE_THREAT_MATRIX_ORG_ID!;
    }
    public static getPaypalSDKURL(): string {
      return import.meta.env.VITE_APP_PAYPAL_SDK_URL!;
    }
    public static getPaypalClientId(): string {
      return import.meta.env.VITE_APP_PAYPAL_CLIENT_ID!;
    }
    public static getPaypalEnvironment(): string {
      return import.meta.env.VITE_APP_PAYPAL_ENVIRONMENT!;
    }
    public static getSecureCDNHost(): string {
      return `https://${this.getCDNHost()}`;
    }
  
  }  